import { actionTypes } from '../actions/retails'

const initial = {
	directors: [],
  brokers: [],
	news: [],
  focus: [],
  avenues: [],
  imis: []
}

export default (state = initial, action) => {
  switch (action.type) {

  	case actionTypes.RECEIVE_DIRECTORS:
      return Object.assign({}, state, {
        directors: action.data
    })

    case actionTypes.RECEIVE_BROKERS:
      return Object.assign({}, state, {
        brokers: action.data
    })

    case actionTypes.RECEIVE_NEWS:
      return Object.assign({}, state, {
        news: action.data
    })

    case actionTypes.RECEIVE_AVENUES:
      return Object.assign({}, state, {
        avenues: action.data
    })

    case actionTypes.RECEIVE_FOCUS:
      return Object.assign({}, state, {
        focus: action.data
    })

    case actionTypes.RECEIVE_IMIS:
      return Object.assign({}, state, {
        imis: action.data
    })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/retails.js